import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VoteApiResponse, VOTE_API_RESPONSE_CODE } from 'util/api';

// {"response_code":"20","stars":"{\"total\":1,\"cat01\":{\"total\":1,\"A1\":1}}"}

export interface CategoryAchievementsState {
  total: number;
  [contestantId: string]: number;
}

export interface AchievementsState {
  total: number;
  status: string;
  categories: {
    [catId: string]: CategoryAchievementsState;
  };
}

const initialState = {
  total: 0,
  status: 'unknown',
  categories: {},
} as AchievementsState;

const achievementsSlice = createSlice({
  name: 'achievements',
  initialState,
  reducers: {
    resetAchievements() {
      return {
        total: 0,
        status: 'unknown',
        categories: {},
      };
    },

    updateAchievements(state, action: PayloadAction<VoteApiResponse>) {
      const response = action.payload;

      if (response.response_code === VOTE_API_RESPONSE_CODE.VALID) {
        const starsString = response.stars;

        try {
          let stars = JSON.parse(starsString);
          const total: number = stars.total || 0;
          delete stars['total'];

          const payload: AchievementsState = {
            total,
            status: 'fulfilled',
            categories: {
              ...stars,
            },
          };

          return payload;
        } catch {}

        return state;
      }
    },
  },
});

export const { updateAchievements, resetAchievements } = achievementsSlice.actions;
export default achievementsSlice.reducer;
